module.exports = __webpack_public_path__ + "static/media/avatar_6.596e58b5.svg";